<template>
  <div align="center">
    <VueApexCharts type="area" height="75" width="1000" :options="chartOptions" :series="[{
      name: title,
      data: values
    }]"></VueApexCharts>
  </div>
</template>

<script setup>
import VueApexCharts from 'vue3-apexcharts';
import {ref} from "vue";

const props = defineProps({
  title: String,
  xTitle: String,
  yTitle: String,
  values: Object
});
const series = ref([]);
const chartOptions = ref({});

chartOptions.value = {
  stroke: {
    curve: 'straight',
    width: 1
  },
  chart: {
    type: 'area',
    stacked: false,
    height: 350,

    zoom: {
      type: 'x',
      enabled: true,
      autoScaleYaxis: true
    },

    toolbar: {
      autoSelected: 'zoom'
    },
  },
  dataLabels: {
    enabled: false
  },
  markers: {
    size: 0,
  },
  title: {
    align: 'left'
  },
  fill: {

    type: 'gradient',
    gradient: {
      shadeIntensity: 1,
      inverseColors: false,
      opacityFrom: 0.5,
      opacityTo: 0,
      stops: [0, 90, 100]
    },
  },
  yaxis: {
    title: {
      text: props.yTitle
    },
    min: 0,
    max: 1,
    tickAmount: 1,
  },
  xaxis: {
    type: 'datetime',
    format: "yyyy-MM-dd HH:mm"
  },
  tooltip: {
    shared: true,
    x: {
      show: true,
      format: "yyyy-MM-dd HH:mm"
    },
    y: {
      show: true,
      title: {
        formatter:(seriesName)=>seriesName,
      }
    }
  }
}

</script>

<style scoped>

</style>